import { createConsumer } from "@rails/actioncable";

const cableUrl =
  (window as any).RAILS_CABLE_URL ||
  (window as any).actionCableUrl ||
  "/cable";

const consumer = createConsumer(cableUrl);

export default consumer;
